
import { Component, Prop } from 'vue-property-decorator';
import LogPageEventMixin, { PAGE_TRACKING, PAGE_EVENTS } from '@/mixins/logPageEvent';
import { mixins } from 'vue-class-component';

@Component
export default class ChatroomWrapper extends mixins(LogPageEventMixin) {
  @Prop(Boolean) readonly isInitializingChatroom!: boolean;
  @Prop(Boolean) readonly isChatroomSelected!: boolean;

  get [PAGE_TRACKING] () {
    if (this.isInitializingChatroom) {
      return null;
    }

    return {
      name: this.isChatroomSelected ? PAGE_EVENTS.CHAT_ROOM : PAGE_EVENTS.ACTIVE_CONVERSATION_TICKET,
    };
  }
}
